import { render, staticRenderFns } from "./SparepartsTable.vue?vue&type=template&id=17d041be"
import script from "./SparepartsTable.vue?vue&type=script&lang=js"
export * from "./SparepartsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports